import { parseApiUtcDateTime } from './parseApiUtcDateTime';

export function formatTimeAgo(dateStr: string, nowMs: number = Date.now()): string {
  const date = parseApiUtcDateTime(dateStr);
  if (!date) return '—';

  const diffMs = Math.max(0, nowMs - date.getTime());
  const mins = Math.floor(diffMs / 60000);
  const hours = Math.floor(diffMs / 3600000);
  const days = Math.floor(diffMs / 86400000);

  if (mins < 1) return 'Just now';
  if (mins < 60) return `${mins}m ago`;
  if (hours < 24) return `${hours}h ago`;
  if (days < 7) return `${days}d ago`;
  return date.toLocaleDateString();
}
